module.exports = __webpack_public_path__ + "img/113.9a3bcfbb.jpg";